var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-icon"},[_c('fa-icon',_vm._b({class:[_vm.color],attrs:{"icon":_vm.icon,"size":_vm.size}},'fa-icon',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }